export default "__VITE_ASSET__ef88f8b9__"